// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__VOoOv","box":"WorkspacesBox_box__3OmA6","node":"WorkspacesBox_node__uL6KE"};